export default "__VITE_ASSET__3a85dfd4__"